import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row g-3"
}
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = {
  key: 1,
  class: "modal"
}
const _hoisted_6 = { class: "modal-content" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "input-group" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "input-group" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "input-group" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = ["disable"]
const _hoisted_16 = { class: "row g-3" }
const _hoisted_17 = { class: "row col-md-7" }
const _hoisted_18 = { class: "el-input-group" }
const _hoisted_19 = { class: "col-md-9" }
const _hoisted_20 = { class: "input-group" }
const _hoisted_21 = { class: "row col-md-7" }
const _hoisted_22 = { class: "el-input-group" }
const _hoisted_23 = { class: "col-md-9" }
const _hoisted_24 = { class: "input-group" }
const _hoisted_25 = { class: "row col-md-7" }
const _hoisted_26 = { class: "el-input-group" }
const _hoisted_27 = { class: "col-md-9" }
const _hoisted_28 = { class: "input-group" }
const _hoisted_29 = { class: "row col-md-7" }
const _hoisted_30 = { class: "el-input-group" }
const _hoisted_31 = { class: "col-md-9" }
const _hoisted_32 = { class: "input-group" }
const _hoisted_33 = { class: "row col-md-7" }
const _hoisted_34 = { class: "el-input-group" }
const _hoisted_35 = { class: "col-md-9" }
const _hoisted_36 = { class: "input-group" }
const _hoisted_37 = { class: "row col-md-7" }
const _hoisted_38 = { class: "el-input-group" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = {
  key: 0,
  class: "ms-3"
}
const _hoisted_41 = { class: "page-content-info d-flex align-items-center justify-content-end" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = { class: "row" }
const _hoisted_44 = { class: "col-md-2" }
const _hoisted_45 = {
  key: 0,
  class: "col-md-2"
}
const _hoisted_46 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_47 = { style: {"color":"red"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_DeleteReasonDialog = _resolveComponent("DeleteReasonDialog")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[46] || (_cache[46] = _createElementVNode("h2", null, "Табель", -1)),
    (_ctx.hasAccess(_ctx.adminRoles))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              class: "open-modal-btn",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args)))
            }, "Загрузить EXCEL табель"),
            _cache[23] || (_cache[23] = _createElementVNode("i", null, "Суммы в excel должны быть тип text и в формате 13547666.31 или 13547666,31", -1)),
            _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
            _cache[25] || (_cache[25] = _createElementVNode("b", null, "Порядок колонок важен", -1)),
            _cache[26] || (_cache[26] = _createElementVNode("p", null, [
              _createElementVNode("a", { href: "/templates/timesheet_example.xlsx" }, "Чтобы скачать пример excel табеля - нажмите по этой строке")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _cache[27] || (_cache[27] = _createTextVNode(" Загрузка Дошкольных Организации ")),
              _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1)),
              _cache[29] || (_cache[29] = _createTextVNode(" В очереди: ")),
              _createElementVNode("b", null, _toDisplayString(_ctx.rabbitQueue), 1)
            ]),
            _cache[33] || (_cache[33] = _createElementVNode("ul", null, null, -1)),
            _createElementVNode("div", null, [
              _cache[30] || (_cache[30] = _createTextVNode(" Предварительный расчет ФЦ по Дошкольным Организациям ")),
              _cache[31] || (_cache[31] = _createElementVNode("br", null, null, -1)),
              _cache[32] || (_cache[32] = _createTextVNode(" В очереди: ")),
              _createElementVNode("b", null, _toDisplayString(_ctx.rabbitQueuePreCalculationAmount), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-info me-3",
        onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.router.push('/timesheet/pre/calculation');})
      }, "Перейти на предварительный расчет табеля"),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-info",
        onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.router.push('/timesheet/general');})
      }, "Перейти на общий табель по ДО")
    ]),
    (_ctx.showModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[38] || (_cache[38] = _createElementVNode("h4", null, "Выберите .xlsx файл для загрузки табеля", -1)),
            _createElementVNode("form", {
              onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _cache[34] || (_cache[34] = _createElementVNode("label", {
                  for: "timesheetType",
                  class: "form-label"
                }, "Тип табеля", -1)),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_multiselect, {
                    modelValue: _ctx.timesheetType,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.timesheetType) = $event)),
                    options: _ctx.timesheetTypeList,
                    searchable: true,
                    closeOnSelect: true,
                    "custom-label": _ctx.formattedTimesheetTypeLabel,
                    placeholder: "Выберите тип табеля",
                    multiple: false,
                    "clear-on-select": true
                  }, null, 8, ["modelValue", "options", "custom-label"])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[35] || (_cache[35] = _createElementVNode("label", {
                  for: "accountingMonth",
                  class: "form-label"
                }, "Расчетный месяц", -1)),
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    max: "12",
                    class: "form-control",
                    id: "accountingMonth",
                    required: "",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchParams.accountingMonth) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.searchParams.accountingMonth]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[36] || (_cache[36] = _createElementVNode("label", {
                  for: "accountingYear",
                  class: "form-label"
                }, "Расчетный год", -1)),
                _createElementVNode("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    min: "2024",
                    class: "form-control",
                    id: "accountingYear",
                    required: "",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchParams.accountingYear) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.searchParams.accountingYear]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _cache[37] || (_cache[37] = _createElementVNode("label", {
                  for: "timesheetFile",
                  class: "form-label"
                }, "Выберите .xlsx файл", -1)),
                _createElementVNode("input", {
                  type: "file",
                  id: "timesheetFile",
                  class: "form-control",
                  required: "",
                  accept: ".xlsx",
                  onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args)))
                }, null, 32)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "submit-btn",
                  disable: _ctx.isLoading
                }, _toDisplayString(_ctx.isLoading ? 'Загружается...' : 'Загрузить'), 9, _hoisted_15)
              ])
            ], 32),
            _createElementVNode("button", {
              class: "close-modal-btn",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, "Закрыть")
          ])
        ]))
      : _createCommentVNode("", true),
    _cache[47] || (_cache[47] = _createElementVNode("br", null, null, -1)),
    _cache[48] || (_cache[48] = _createElementVNode("br", null, null, -1)),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _cache[39] || (_cache[39] = _createElementVNode("label", {
            for: "timesheetType",
            class: "form-label col-md-3"
          }, "Тип табеля", -1)),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_multiselect, {
                modelValue: _ctx.timesheetType,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.timesheetType) = $event)),
                options: _ctx.timesheetTypeList,
                searchable: true,
                closeOnSelect: true,
                "custom-label": _ctx.formattedTimesheetTypeLabel,
                placeholder: "Выберите тип табеля",
                multiple: false,
                "clear-on-select": true
              }, null, 8, ["modelValue", "options", "custom-label"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _cache[40] || (_cache[40] = _createElementVNode("label", {
            for: "bin",
            class: "form-label col-md-3"
          }, "БИН", -1)),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "bin",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.searchParams.bin) = $event))
              }, null, 512), [
                [_vModelText, _ctx.searchParams.bin]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _cache[41] || (_cache[41] = _createElementVNode("label", {
            for: "lmsId",
            class: "form-label col-md-3"
          }, "LMS ID", -1)),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "lmsId",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.searchParams.lmsId) = $event))
              }, null, 512), [
                [_vModelText, _ctx.searchParams.lmsId]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _cache[42] || (_cache[42] = _createElementVNode("label", {
            for: "accountingMonth",
            class: "form-label col-md-3"
          }, "Расчетный месяц", -1)),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                max: "12",
                class: "form-control",
                id: "accountingMonth",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.searchParams.accountingMonth) = $event))
              }, null, 512), [
                [_vModelText, _ctx.searchParams.accountingMonth]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _cache[43] || (_cache[43] = _createElementVNode("label", {
            for: "accountingYear",
            class: "form-label col-md-3"
          }, "Расчетный год", -1)),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                min: "2024",
                class: "form-control",
                id: "accountingYear",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.searchParams.accountingYear) = $event))
              }, null, 512), [
                [_vModelText, _ctx.searchParams.accountingYear]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.fetchTimesheetData && _ctx.fetchTimesheetData(...args))),
            disabled: _ctx.fetchLoading
          }, _toDisplayString(!_ctx.fetchLoading ? "Поиск" : "Загрузка..."), 9, _hoisted_39),
          (_ctx.hasAccess(_ctx.adminWriteRoles))
            ? (_openBlock(), _createElementBlock("label", _hoisted_40, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.searchParams.includeDeleted) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.searchParams.includeDeleted]
                ]),
                _cache[44] || (_cache[44] = _createTextVNode(" Показать удалённые "))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_41, [
      _createElementVNode("button", {
        disabled: (_ctx.timesheetResponse.length === 0),
        class: "btn btn-info",
        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.downloadGeneratedCalculationReportList()))
      }, "Выгрузить результат по фильтру ", 8, _hoisted_42)
    ]),
    _createElementVNode("div", _hoisted_43, [
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("span", null, "Элементов: " + _toDisplayString(_ctx.timesheetResponse.length), 1)
      ]),
      (_ctx.hasAccess(_ctx.adminRoles))
        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
            _createElementVNode("span", null, "Выбрано: " + _toDisplayString(_ctx.selectionTimesheetDataList.length), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.hasAccess(_ctx.adminRoles))
        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
            (_ctx.selectedLive.length > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-danger",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showDeleteConfirmationModal = true))
                }, "Удалить выбранные элементы (" + _toDisplayString(_ctx.selectedLive.length) + ")", 1))
              : _createCommentVNode("", true),
            (_ctx.hasAccess(_ctx.adminWriteRoles) && _ctx.selectedDeleted.length > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "btn btn-success ms-2",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.showRestoreModal = true))
                }, "Восстановить (" + _toDisplayString(_ctx.selectedDeleted.length) + ")", 1))
              : _createCommentVNode("", true),
            (_ctx.hasAccess(_ctx.adminWriteRoles) && _ctx.timesheetsInResult.length > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  type: "button",
                  class: "btn btn-outline-danger ms-2",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showRemoveTimesheetModal = true))
                }, "Удалить табель целиком" + _toDisplayString(_ctx.timesheetsInResult.length > 1 ? ` (${_ctx.timesheetsInResult.length})` : ""), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_DeleteReasonDialog, {
      modelValue: _ctx.showDeleteConfirmationModal,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.showDeleteConfirmationModal) = $event)),
      title: "Вы точно хотите удалить выбранные строки из табеля?",
      loading: _ctx.fetchLoading,
      onConfirm: _ctx.handleDeleteSelectedElements
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, "Выбрано строк: " + _toDisplayString(_ctx.selectionTimesheetDataList.length) + ". После удаления табель будет пересчитан.", 1)
      ]),
      _: 1
    }, 8, ["modelValue", "loading", "onConfirm"]),
    _createVNode(_component_DeleteReasonDialog, {
      modelValue: _ctx.showRestoreModal,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.showRestoreModal) = $event)),
      variant: "restore",
      title: "Восстановить выбранные строки табеля?",
      "confirm-text": "Восстановить",
      "reason-label": "Причина восстановления",
      loading: _ctx.fetchLoading,
      onConfirm: _ctx.handleRestoreSelectedElements
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, "Выбрано строк: " + _toDisplayString(_ctx.selectedDeleted.length) + ". После восстановления табель будет пересчитан.", 1)
      ]),
      _: 1
    }, 8, ["modelValue", "loading", "onConfirm"]),
    _createVNode(_component_DeleteReasonDialog, {
      modelValue: _ctx.showRemoveTimesheetModal,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.showRemoveTimesheetModal) = $event)),
      title: "Удалить табель целиком?",
      "confirm-text": "Удалить табель",
      loading: _ctx.fetchLoading,
      onConfirm: _ctx.handleRemoveTimesheets
    }, {
      default: _withCtx(() => [
        _cache[45] || (_cache[45] = _createElementVNode("p", null, "Будут удалены безвозвратно все строки табеля (включая созданные расчётом и ранее удалённые), общие сведения и сам табель. Восстановить можно только повторной загрузкой из LMS. Подписанные расчёты за этот месяц не трогаются.", -1)),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timesheetsInResult, (t) => {
            return (_openBlock(), _createElementBlock("li", {
              key: t.monthlyTimesheetId
            }, _toDisplayString(t.name) + " (БИН " + _toDisplayString(t.bin) + ", LMS ID " + _toDisplayString(t.lmsId) + "), " + _toDisplayString(_ctx.searchParams.accountingMonth) + "." + _toDisplayString(_ctx.searchParams.accountingYear) + " — строк: " + _toDisplayString(t.rows), 1))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "loading", "onConfirm"]),
    _createVNode(_component_el_table, {
      ref: "multipleTableRef",
      onSelectionChange: _ctx.handleSelectionChange,
      data: _ctx.timesheetResponse,
      "row-class-name": _ctx.rowClassName,
      style: {"width":"100%"},
      border: "",
      height: "95vh"
    }, {
      default: _withCtx(() => [
        (_ctx.hasAccess(_ctx.adminRoles))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              type: "selection"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          type: "index",
          label: "#"
        }),
        _createVNode(_component_el_table_column, { label: "Текст ошибки" }, {
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_47, _toDisplayString(scope.row.errorText), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "bin",
          label: "БИН ДО"
        }),
        _createVNode(_component_el_table_column, {
          prop: "lmsId",
          label: "LMS ID"
        }),
        _createVNode(_component_el_table_column, {
          prop: "arrivedDate",
          label: "Прибытия"
        }),
        _createVNode(_component_el_table_column, {
          prop: "departureDate",
          label: "Выбытия"
        }),
        _createVNode(_component_el_table_column, {
          prop: "regionGroup",
          label: "Регион группа"
        }),
        _createVNode(_component_el_table_column, {
          prop: "localityType",
          label: "Тип населенного пункта"
        }),
        _createVNode(_component_el_table_column, {
          prop: "regionType",
          label: "Регион тип"
        }),
        _createVNode(_component_el_table_column, {
          prop: "ownershipType",
          label: "Тип собственности"
        }),
        _createVNode(_component_el_table_column, {
          prop: "durationTime",
          label: "Время прибывание"
        }),
        _createVNode(_component_el_table_column, {
          prop: "educationalType",
          label: "Тип образование"
        }),
        _createVNode(_component_el_table_column, {
          prop: "timesheetType",
          label: "Тип табеля"
        }),
        _createVNode(_component_el_table_column, {
          prop: "presenceDays",
          label: "Дни прибывание"
        }),
        _createVNode(_component_el_table_column, {
          prop: "planningDays",
          label: "Плановые дни"
        }),
        _createVNode(_component_el_table_column, {
          prop: "recalculationAmount",
          label: "Сумма перерасчета LMS"
        }),
        _createVNode(_component_el_table_column, {
          prop: "preReconciliationSum",
          label: "Сумма перерасчета ФЦ"
        }),
        _createVNode(_component_el_table_column, { label: "Сумма LMS" }, {
          default: _withCtx((scope) => [
            _createElementVNode("p", {
              class: _normalizeClass({
                'text-danger': Math.abs(scope.row.preCalculationAmount - scope.row.totalToAccrueLms) > 1000,
                'text-warning': Math.abs(scope.row.preCalculationAmount - scope.row.totalToAccrueLms) < 1000 && Math.abs(scope.row.preCalculationAmount - scope.row.totalToAccrueLms) > 0,
                'text-success': Math.abs(scope.row.preCalculationAmount - scope.row.totalToAccrueLms) == 0,
              })
            }, _toDisplayString(scope.row.totalToAccrueLms), 3)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "Предварительный расчет ФЦ" }, {
          default: _withCtx((scope) => [
            _createElementVNode("p", {
              class: _normalizeClass({
                'text-danger': Math.abs(scope.row.preCalculationAmount - scope.row.totalToAccrueLms) > 1000,
                'text-warning': Math.abs(scope.row.preCalculationAmount - scope.row.totalToAccrueLms) < 1000 && Math.abs(scope.row.preCalculationAmount - scope.row.totalToAccrueLms) > 0,
                'text-success': Math.abs(scope.row.preCalculationAmount - scope.row.totalToAccrueLms) == 0,
              })
            }, _toDisplayString(scope.row.preCalculationAmount), 3)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "voucherType",
          label: "Ваучер"
        }),
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "Название ДО"
        }),
        _createVNode(_component_el_table_column, {
          prop: "lmsName",
          label: "Название LMS"
        }),
        _createVNode(_component_el_table_column, {
          prop: "totalDaysOnMonth",
          label: "Дни в месяце"
        }),
        _createVNode(_component_el_table_column, {
          prop: "workingDays",
          label: "Рабочие дни"
        }),
        _createVNode(_component_el_table_column, {
          prop: "weekendDays",
          label: "Выходные дни"
        }),
        _createVNode(_component_el_table_column, {
          prop: "childIin",
          label: "ИИН ребенка"
        }),
        _createVNode(_component_el_table_column, {
          prop: "passportNumber",
          label: "Паспорт ребенка"
        }),
        _createVNode(_component_el_table_column, {
          prop: "childFirstName",
          label: "Имя ребенка"
        }),
        _createVNode(_component_el_table_column, {
          prop: "childLastName",
          label: "Фамилия"
        }),
        _createVNode(_component_el_table_column, {
          prop: "childMiddleName",
          label: "Отчество"
        }),
        _createVNode(_component_el_table_column, {
          prop: "parentIin",
          label: "ИИН родителя"
        }),
        _createVNode(_component_el_table_column, {
          prop: "parentFirstName",
          label: "Имя родителя"
        }),
        _createVNode(_component_el_table_column, {
          prop: "parentLastName",
          label: "Фамилия"
        }),
        _createVNode(_component_el_table_column, {
          prop: "parentMiddleName",
          label: "Отчество"
        }),
        _createVNode(_component_el_table_column, {
          prop: "phoneNumber",
          label: "Телефона"
        }),
        _createVNode(_component_el_table_column, {
          prop: "escrowAccount",
          label: "escrowAccount"
        }),
        _createVNode(_component_el_table_column, {
          prop: "excusedAbsenceDays",
          label: "Отсутствие с причиной"
        }),
        _createVNode(_component_el_table_column, {
          prop: "unexcusedAbsenceDays",
          label: "Отсутствие без причины"
        }),
        _createVNode(_component_el_table_column, {
          prop: "sickLeaveDays",
          label: "Больничные дни"
        }),
        _createVNode(_component_el_table_column, {
          prop: "haveSickLeave",
          label: "haveSickLeave"
        }),
        _createVNode(_component_el_table_column, {
          prop: "matchSickLeavePeriod",
          label: "matchSickLeavePeriod"
        }),
        _createVNode(_component_el_table_column, {
          prop: "vacationDays",
          label: "Дни отпуска"
        }),
        _createVNode(_component_el_table_column, {
          prop: "isVacationStatement",
          label: "isVacationStatement"
        }),
        _createVNode(_component_el_table_column, {
          prop: "matchVacationPeriod",
          label: "matchVacationPeriod"
        }),
        _createVNode(_component_el_table_column, {
          prop: "isAgreed",
          label: "Согласован"
        }),
        _createVNode(_component_el_table_column, {
          prop: "consentDate",
          label: "Дата согласование"
        }),
        _createVNode(_component_el_table_column, {
          prop: "approverIin",
          label: "ИИН согласующего"
        }),
        _createVNode(_component_el_table_column, {
          prop: "approverFirstName",
          label: "Имя"
        }),
        _createVNode(_component_el_table_column, {
          prop: "approverLastName",
          label: "Фамилия"
        }),
        _createVNode(_component_el_table_column, {
          prop: "approverMiddleName",
          label: "Отчество"
        }),
        _createVNode(_component_el_table_column, {
          prop: "absenceRedLine",
          label: "БП более 40 дней"
        }),
        _createVNode(_component_el_table_column, {
          prop: "lmsDocumentId",
          label: "Lms Document Id"
        }),
        _createVNode(_component_el_table_column, {
          prop: "lmsChildId",
          label: "Lms Child Id"
        }),
        _createVNode(_component_el_table_column, {
          prop: "createdBy",
          label: "Created by"
        }),
        _createVNode(_component_el_table_column, {
          prop: "seats",
          label: "Сколько место занимает контингент"
        })
      ]),
      _: 1
    }, 8, ["onSelectionChange", "data", "row-class-name"])
  ]))
}